import { render, staticRenderFns } from "./TaxsetGrid.vue?vue&type=template&id=6a4e8fe8"
import script from "./TaxsetGrid.vue?vue&type=script&lang=js"
export * from "./TaxsetGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports